import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import { nextTick } from 'vue'

export const locationSearchMixin = {
  mixins: [ GeoipCountryMixin ],

  props: {
    customPlaceholderText: {
      type: String,
      required: false
    },
    customSearchButtonText: {
      type: String,
      required: false
    },
    distanceHint: {
      type: String,
      required: false,
      default: ''
    },
    extraParameters: {
      type: Object,
      required: false,
      default: () => ({})
    },
    initialLocationQuery: {
      type: String,
      required: false,
      default: ''
    },
    lookupUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      searchQuery: this.initialLocationQuery
    }
  },

  computed: {
    extraParameterPairs() {
      return Object.entries(this.extraParameters).map(e => ({name: e[0], value: e[1]}))
    },

    searchBiasCountry() {
      return this.agraConfiguration.locationSearchBias.country
    },

    searchButtonText() {
      if (this.customSearchButtonText !== undefined) {
        return this.customSearchButtonText
      } else {
        return this.i18n.t('buttons.lookup')
      }
    }
  },

  methods: {
    search(query) {
      this.searchQuery = query
      nextTick(() => {
        this.$refs.form.submit()
      })
    }
  }
}
